import { publicApiQuery } from '../';

export const publicIntroApi = publicApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getPublicIntroByGuid: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ introId }) => {
          return {
            method: 'get',
            url: `/intros/public/${introId}`,
          };
        },
      }),
      addEmailPublicIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ introId, email }) => {
          return {
            method: 'put',
            url: `/intros/add_email/${introId}`,
            data: {
              email,
            },
          };
        },
      }),
      declinePublicIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ introId }) => {
          return {
            method: 'put',
            url: `/intros/public_deny/${introId}`,
          };
        },
      }),
      acceptPublicIntro: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ introId }) => {
          return {
            method: 'put',
            url: `/intros/public_accept/${introId}`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetPublicIntroByGuidQuery,
  useAddEmailPublicIntroMutation,
  useDeclinePublicIntroMutation,
  useAcceptPublicIntroMutation,
} = publicIntroApi;
